interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseClasses = 'w-full font-bold rounded-xl shadow-lg transform transition hover:scale-95 active:scale-90 flex items-center justify-center gap-2'
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : ''
  const sizeClasses = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg',
  }

  const variantClasses = {
    primary: 'bg-gradient-to-r from-blue-500 to-purple-600 text-white',
    secondary: 'bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900',
    outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary/10',
    ghost: 'text-gray-400 hover:text-white hover:bg-gray-800',
  }

  return (
    <button
      type="button"
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
